import { formatPercent } from '@shared/helpers/format-currency';
import type { Product } from '../../../data/product';
import { defineColumn, type StrictColumnDef } from '../../tanstack-table/column';

export const SavingsPercentage: StrictColumnDef<Product> = defineColumn<Product>({
  id: 'Savings %',
  minWidth: 80,
  accessorFn: (product) => {
    if (!product.pricing.current_cost || !product.pricing.future_cost) {
      return '';
    }

    const savingsPercentage =
      (product.pricing.future_cost - product.pricing.current_cost) / product.pricing.current_cost;

    return formatPercent(savingsPercentage);
  },
  cell: ({ value }) => (
    <span className={value.startsWith('-') ? 'text-red-600' : 'text-green-600'}>{value}</span>
  ),
});
